/*
  INGEMA · Galería de la edición (sección Edición 01 de la portada).
  Funciona sola (deslizar, miniaturas, flechas, teclado, contador y barra) aunque Motion no cargue.
  Con Motion (y sin "reducir movimiento") suma:
    - entrada: el marco se abre, la foto se acerca y las miniaturas suben en cascada;
    - en cada cambio: la foto respira y el número del contador sube o baja;
    - en computadora: el marco se inclina un poco siguiendo el mouse.
  Avanza sola cada 4,2 s mientras se ve en pantalla; se detiene para siempre cuando la persona la toca.
*/
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var EASE = [0.22, 1, 0.36, 1];
  var AUTO_MS = 4200;

  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function motion() { return !reduce && window.Motion && window.Motion.animate ? window.Motion : null; }
  function pad(i) { return (i < 10 ? '0' : '') + i; }

  function init(gal) {
    var track = gal.querySelector('[data-ig-gal-track]');
    var frame = gal.querySelector('[data-ig-gal-frame]');
    var slides = $$('[data-ig-gal-slide]', gal);
    var thumbs = $$('[data-ig-gal-thumb]', gal);
    var thumbBox = gal.querySelector('[data-ig-gal-thumbs]');
    var nowEl = gal.querySelector('[data-ig-gal-now]');
    var bar = gal.querySelector('[data-ig-gal-bar]');
    var prev = gal.querySelector('[data-ig-gal-prev]');
    var next = gal.querySelector('[data-ig-gal-next]');
    var glow = gal.querySelector('.ig-gal__glow');
    var n = slides.length;
    var index = 0;
    var touched = false;
    var visible = false;
    var timer = null;
    if (!track || n < 2) return;

    function warm(i) {
      for (var k = i; k <= i + 2; k++) {
        var im = slides[(k + n) % n].querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
      }
    }

    var target = null;   /* mientras la galería se desliza sola hacia una foto, no contar las intermedias */
    var targetTimer = null;
    function go(i) {
      i = (i + n) % n;
      setIndex(i);
      target = i;
      clearTimeout(targetTimer);
      targetTimer = setTimeout(function () { target = null; }, 1200);
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    function setIndex(i) {
      if (i === index || i < 0 || i >= n) return;
      var dir = i > index ? 1 : -1;
      index = i;
      warm(i + 1);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (thumbBox && thumbBox.scrollWidth > thumbBox.clientWidth && thumbs[i]) {
        var t = thumbs[i];
        thumbBox.scrollTo({ left: t.offsetLeft - (thumbBox.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (bar) bar.style.transform = 'translateX(' + i * 100 + '%)';
      var m = motion();
      if (nowEl) {
        nowEl.textContent = pad(i + 1);
        if (m) m.animate(nowEl, { transform: ['translateY(' + dir * 100 + '%)', 'translateY(0%)'], opacity: [0, 1] }, { duration: 0.45, ease: EASE });
      }
      var img = slides[i].querySelector('img');
      if (m && img) m.animate(img, { scale: [1.08, 1] }, { duration: 1.1, ease: EASE });
    }

    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (target !== null) {
        if (i === target) target = null;
        return;
      }
      setIndex(i);
    }, { passive: true });

    /* controles */
    function stop() { touched = true; pause(); }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { stop(); go(k); }); });
    if (prev) prev.addEventListener('click', function () { stop(); go(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(index + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(index + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(index - 1); }
    });
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
      track.addEventListener(ev, function () { target = null; stop(); }, { passive: true });
    });

    /* avance solo, mientras se ve */
    function play() {
      if (reduce || touched || timer || !visible || document.hidden) return;
      timer = setInterval(function () { go(index + 1); }, AUTO_MS);
    }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }
    gal.addEventListener('mouseenter', pause);
    gal.addEventListener('mouseleave', play);
    gal.addEventListener('focusin', pause);
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else play(); });

    /* entrada con Motion la primera vez que aparece (solo si está fuera de pantalla al cargar) */
    var m = motion();
    var firstImg = slides[0].querySelector('img');
    var below = gal.getBoundingClientRect().top > window.innerHeight * 0.85;
    var entered = false;
    if (m && below) {
      frame.style.clipPath = 'inset(10% 8% 10% 8%)';
      frame.style.opacity = '0';
      thumbs.forEach(function (t) { t.style.opacity = '0'; });
      /* red de seguridad: si no hay cuadros (pestaña de fondo, robots), a los 4 s queda visible */
      setTimeout(function () {
        if (entered) return;
        frame.style.clipPath = ''; frame.style.opacity = '';
        thumbs.forEach(function (t) { t.style.opacity = ''; });
      }, 4000);
    }
    function enter() {
      if (entered) return;
      entered = true;
      warm(1);
      if (!m || !below) return;
      m.animate(frame, { clipPath: ['inset(10% 8% 10% 8%)', 'inset(0% 0% 0% 0%)'], opacity: [0, 1] }, { duration: 1, ease: EASE })
        .then(function () { frame.style.clipPath = ''; });
      if (firstImg) m.animate(firstImg, { scale: [1.18, 1] }, { duration: 1.5, ease: EASE });
      if (glow) m.animate(glow, { opacity: [0, 1], scale: [0.7, 1] }, { duration: 1.4, ease: EASE });
      m.animate(thumbs, { opacity: [0, 1], transform: ['translateY(14px)', 'translateY(0px)'] }, {
        duration: 0.5, ease: EASE, delay: m.stagger(0.05, { startDelay: 0.35 })
      }).then(function () { thumbs.forEach(function (t) { t.style.transform = ''; t.style.opacity = ''; }); });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) { enter(); play(); } else { pause(); }
        });
      }, { threshold: 0.35 }).observe(frame);
    } else {
      visible = true; enter(); play();
    }

    /* computadora: el marco se inclina un poco siguiendo el mouse */
    if (m && fine) {
      var spring = { type: 'spring', stiffness: 160, damping: 18 };
      frame.addEventListener('pointermove', function (e) {
        var r = frame.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        m.animate(frame, { rotateY: px * 5, rotateX: py * -5 }, spring);
      });
      frame.addEventListener('pointerleave', function () {
        m.animate(frame, { rotateY: 0, rotateX: 0 }, spring);
      });
    }
  }

  function start() { $$('[data-ig-gal]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* Editor de temas: volver a iniciar cuando se recarga la sección */
  document.addEventListener('shopify:section:load', function (e) { $$('[data-ig-gal]', e.target).forEach(init); });
})();
